import { LabelStyle } from "./types";

export function getLabelStyle(idx: number): LabelStyle {
    return labelStyles[idx % labelStyles.length];
}

export const labelStyles: LabelStyle[] = [
    { color: "#fdab3d", border: "#E99729", var_name: "orange" },
    { color: "#00c875", border: "#00B461", var_name: "green-shadow" },
    { color: "#e2445c", border: "#CE3048", var_name: "red-shadow" },
    { color: "#c4c4c4", border: "#B0B0B0", var_name: "grey" },
    { color: "#579bfc", border: "#4387E8", var_name: "bright-blue" },
    { color: "#FF158A", border: "#E01279", var_name: "dark-pink" },
    { color: "#784BD1", border: "#8F4DC4", var_name: "dark-purple" },
    { color: "#0086c0", border: "#3DB0DF", var_name: "blue-links" },
    { color: "#a25ddc", border: "#9238AF", var_name: "purple" },
    { color: "#037f4c", border: "#006B38", var_name: "grass-green" },
    { color: "#CAB641", border: "#C0AB31", var_name: "mustered" },
    { color: "#FFCB00", border: "#C0AB1B", var_name: "yellow" },
    { color: "#333333", border: "#000", var_name: "soft-black" },
    { color: "#BB3354", border: "#A42D4A", var_name: "dark-red" },
    { color: "#FF5AC4", border: "#E04FAC", var_name: "light-pink" },
    { color: "#9CD326", border: "#89B921", var_name: "lime-green" },
    { color: "#66CCFF", border: "#5AB3E0", var_name: "turquoise" },
    { color: "#808080", border: "#707070", var_name: "trolley-grey" },
    { color: "#7F5347", border: "#70493E", var_name: "brown" },
    { color: "#FF642E", border: "#E05828", var_name: "dark-orange" },
    { color: "#ff7575", border: "#ff7575", var_name: "sunset" },
    { color: "#faa1f1", border: "#faa1f1", var_name: "bubble" },
    { color: "#ffadad", border: "#ffadad", var_name: "peach" },
    { color: "#7E3B8A", border: "#7E3B8A", var_name: "berry" },
    { color: "#9AADBD", border: "#9AADBD", var_name: "winter" },
    { color: "#68a1bd", border: "#68a1bd", var_name: "river" },
    { color: "#225091", border: "#225091", var_name: "navy" },
    { color: "#4eccc6", border: "#4eccc6", var_name: "australia" },
    { color: "#5559df", border: "#5559df", var_name: "indigo" },
    { color: "#401694", border: "#401694", var_name: "dark_indigo" }
];

export const replayFrameMs = 500;

export type Speed = { duration: number; name: string };
export const replaySpeeds: Speed[] = [
    {
        duration: 300,
        name: "5 min"
    },
    {
        duration: 60,
        name: "1 min"
    },
    {
        duration: 30,
        name: "30 s"
    },
    {
        duration: 15,
        name: "15 s"
    },
    {
        duration: 10,
        name: "10 s"
    }
];
